<template>
    <div class="x_body">
        <b-row class="card-pos" style="height: 10vh; margin-bottom: 15px;">
            <b-col sm="12">
                <div class="align-center" style="justify-content: start; padding-left: 15px;">
                    <button type="button" class="btn btn-default" @click="showTender"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i></button>
                </div>
            </b-col>
        </b-row>
        <b-row style="height: 85vh; margin: 0px 15px;">
            <b-col sm="4" class="card-pos">
                <b-row>
                    <b-col sm="12" style="padding-top: 15px;">
                        <b-list-group>
                            <b-list-group-item class="d-flex align-items-center">
                                <b-avatar class="mr-3 b-avatar-custom"></b-avatar>
                                <span class="mr-auto">{{summary.CustomerName}}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col sm="12" style="padding-top: 15px; height: calc(100% - 190px); top: 60px; position: absolute;">
                        <div class="hide-scroll-bar" style="overflow-y: scroll;">
                            <b-list-group>
                                <template v-for="(ret, index) in orderItems">
                                    <b-list-group-item class="d-flex align-items-center b-list-group-item-custom">
                                        <b-avatar class="mr-3 b-avatar-custom"></b-avatar>
                                        <div class="mr-auto">
                                            <span style="margin-left: 0.25rem;">{{ret.Name}}</span>
                                            <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button @click="$emit('addItem', ret, false)">-</b-button>
                                                </b-button-group>
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button>{{ret.Quantity}}</b-button>
                                                </b-button-group>
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button @click="$emit('addItem', ret, true)">+</b-button>
                                                </b-button-group>
                                            </b-button-toolbar>
                                        </div>
                                        <span style="color: #ff0000;">{{$dollar(ret.SubTotal)}}</span>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                    </b-col>
                    <b-col sm="12" style="padding-top: 15px; position: absolute; bottom: 15px;">
                        <div>
                            <span>{{$t('sub_total')}} (3 {{$t('items')}})</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.SubTotal)}}</span>
                        </div>
                        <div>
                            <span>{{$t('tax_includes')}}</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.Tax)}}</span>
                        </div>
                        <div>
                            <span>{{$t('discount')}}</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.Discount)}}</span>
                        </div>
                        <div style="font-weight: bold;">
                            <span>{{$t('grand_total')}}</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.GrandTotal)}}</span>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="8">
                <b-row>
                    <b-col sm="6">
                        <b-list-group>
                            <b-list-group-item class="d-flex align-items-center" style="height: 65px;">
                                <div class="mr-auto">{{$t('tender_amount')}}</div>
                                <span style="color: #ff0000; font-weight: bold; font-size: 25px;">{{$dollar(summary.GrandTotal)}}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col sm="6">
                        <b-list-group>
                            <b-list-group-item class="d-flex align-items-center" style="height: 65px;">
                                <div class="mr-auto">{{$t('tender_amount')}}</div>
                                <span style="color: #ff0000; font-weight: bold; font-size: 25px;">{{$riel(summary.GrandTotal)}}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 30px;">
                    <b-col sm="4">
                        <b-form-group :label="$t('payment_receive')">
                            <b-form-input v-model.number="summary.PaymentReceive"
                                          @input="changePaymentReceive"
                                          @keypress.enter="onSave"
                                          size="lg"
                                          style="color: #ff0000; font-weight: bold; font-size: 25px;"
                                          type="number"
                                          autofocus />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('payment_refund') + ' ($)'">
                            <b-form-input :value="summary.PaymentRefundUsd"
                                          size="lg"
                                          style="color: #ff0000; font-weight: bold; font-size: 25px; background-color: #fff;"
                                          readonly />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('payment_refund') + ' (៛)'">
                            <b-form-input :value="summary.PaymentRefundRiel"
                                          size="lg"
                                          style="color: #ff0000; font-weight: bold; font-size: 25px; background-color: #fff;"
                                          readonly />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: {
            summaryProp: Object,
            orderItemsProp: Array
        },
        data: function () {
            return {
                orderItems: this.orderItemsProp,
                summary: this.summaryProp
            }
        },
        methods: {
            onSave() {
                const items = this.orderItems.filter(el => el.Quantity > 0);
                if (this.summary.PaymentReceive < this.summary.GrandTotal) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: this.$t('message'),
                        text: this.$t('you_can_not_pay_less_than_order_amount')
                    });
                } else if (items.length == 0) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: this.$t('message'),
                        text: this.$t('there_is_no_products_to_sold')
                    });
                } else if (this.$isEmpty(this.summary.CustomerId)) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: this.$t('message'),
                        text: this.$t('please_select_customer')
                    });
                } else {
                    this.summary.CompanyId = this.$store.state.company.Id;
                    this.summary.ClientId = this.$store.state.company.ClientId;
                    this.summary.UntaxAmount = this.summary.GrandTotal - this.summary.Tax;
                    this.summary.TotalAmount = this.summary.GrandTotal;

                    const body = {
                        Header: this.summary,
                        Lines: items
                    };
                    var loading = this.$loading.show();
                    this.$api().post('sale/invoice/save', body).then(res => {
                        if (this.$isValid(res)) {
                            const data = {
                                isShowTender: false,
                                summary: {
                                    SubTotal: 0,
                                    Discount: 0,
                                    Tax: 0,
                                    GrandTotal: 0,
                                    CustomerId: '',
                                    CustomerName: this.$t('customer_name'),
                                    PaymentReceive: '',
                                    PaymentRefundUsd: 0,
                                    PaymentRefundRiel: 0,
                                    UntaxAmount: 0,
                                    TotalAmount: 0,
                                    PaidStatus: "Paid"
                                },
                                orderItems: []
                            };
                            this.$emit("showTender", data);
                        }
                    }).finally(function () { loading.hide(); });
                }
            },
            showTender() {
                const data = {
                    isShowTender: false,
                    summary: this.summary,
                    orderItems: this.orderItems
                };
                this.$emit("showTender", data);
            },
            changePaymentReceive() {
                const amount = this.summary.paymentReceive - this.summary.GrandTotal;
                if (amount > 0) {
                    this.$set(this.summary, 'PaymentRefundUsd', this.$dollar(amount));
                    this.$set(this.summary, 'PaymentRefundRiel', this.$riel(amount));
                } else {
                    this.$set(this.summary, 'PaymentRefundUsd', this.$dollar(0));
                    this.$set(this.summary, 'PaymentRefundRiel', this.$riel(0));
                }
            }
        }
    };
</script>
